import React, { Component } from 'react';
import Icon from '~/ui/ReactML/Icon';
import { Box } from '~/native-ui/native-base';
import { renderHTML } from '~/native-ui/utils';
import { FormControl } from '~/native-ui/FormControl';

export class ReadonlyField extends Component {
    static propTypes = {};
    static defaultProps = {
        overflowChars: 255,
        inline: false,
        renderAsHtml: false,
    };

    renderMyHtml = (html) =>
        renderHTML(html, {
            icon: Icon,
        });

    render() {
        let { label, tooltip, children } = this.props;
        let value = this.props.value;

        return (
            <FormControl>
                {label && <FormControl.Label label={label} tooltip={tooltip} />}

                {this.props.renderAsHtml ? (
                    <Box className="innerValue" py="10px" fontSize="14">
                        {this.renderMyHtml(value)}
                    </Box>
                ) : (
                    <Box whiteSpace="pre" fontSize="14" py="10px" className="innerValue">
                        {value}
                    </Box>
                )}
                {children}
            </FormControl>
        );
    }
}
